import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import '../Leaves/Leave.css';

const inivalue = {
    minExpYear: "",
    maxExpYear: "",
}

const AddExperience = (props) => {
    const classes = props;
    const [exp, setExp] = useState(inivalue);
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);


    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setExp({ ...exp, [name]: value });

    };

    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;
        const ds = /^[0-9\b]+$/;
        // const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;



        if (!ds.test(values.minExpYear)) {
            errors.minExpYear = "only numeric";
        }

        if (!ds.test(values.maxExpYear)) {
            errors.maxExpYear = "only numeric";
        }






        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const errors = validate(exp);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await experience();
    };


    const experience = async () => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });
        try {
            let create = await AuthApi.createExperience(exp);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Experience added successfully", "success").then(() => {
                    props.history.push('/experience');
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: create && create.message ? create.message : "Something went wrong, Please try later!"
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating experience:", error);
            swal("Error", "An unexpected error occurred", "error");
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Experience"
                                    primaryPageLink="/experience"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Experience" />
                        </div>
                        <div className="holiday-form-card">
                                        <Typography variant="h2" className="common-form-page-title holiday-form-title">Add Experience</Typography>
                                        <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit} >
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="minExpYear"
                                                        name="minExpYear"
                                                        label="MinExpYear"
                                                        variant="outlined"
                                                        error={formErrors.minExpYear && true}
                                                        value={exp.minExpYear}
                                                        onChange={handleChange}
                                                        className={formErrors.minExpYear && "input-error"}

                                                    />
                                                    {formErrors.minExpYear && (
                                                        <span className="error">{formErrors.minExpYear}</span>
                                                    )}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="maxExpYear"
                                                        name="maxExpYear"
                                                        label="MaxExpYear"
                                                        variant="outlined"
                                                        error={formErrors.maxExpYear && true}
                                                        value={exp.maxExpYear}
                                                        onChange={handleChange}
                                                        className={formErrors.maxExpYear && "input-error"}

                                                    />
                                                    {formErrors.maxExpYear && (
                                                        <span className="error">{formErrors.maxExpYear}</span>
                                                    )}
                                                </Grid>







                                            </Grid>

                                            <div className="holiday-form-actions">
                                                <Button type="submit" className="btn-success" style={{ textTransform: 'none' }} variant="contained" color="primary" disabled={submitLoading}>
                                                    {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Save'}
                                                </Button>
                                                <Button type="button" className="btn-cancel" style={{ textTransform: 'none' }} disabled={submitLoading} onClick={(e) => { e.preventDefault(); props.history.push('/experience') }}>Cancel</Button>
                                            </div>
                                        </form>
                        </div>
                    </div>
                } />
            <Footer />
        </div>
    )
}

export default AddExperience;

